module.exports = __webpack_public_path__ + "img/kkb_dimmer.eba502ce.gif";